// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.our-services {
    background-color: #faf8f8;
    padding: auto 0;
  }
  
  .services-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .service {
    width: 300px;
    margin: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .service-icon {
    font-size: 48px;
    color: #00bcd4;
  }
  
  .service-title {
    font-size: 24px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  
  .service-description {
    font-size: 18px;
    line-height: 1.5;
    color: #999;
  }
  
  @media (max-width: 768px) {
    .service {
      width: 100%;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/css/Features.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE;MACE,WAAW;IACb;EACF","sourcesContent":[".our-services {\n    background-color: #faf8f8;\n    padding: auto 0;\n  }\n  \n  .services-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n  \n  .service {\n    width: 300px;\n    margin: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n  \n  .service-icon {\n    font-size: 48px;\n    color: #00bcd4;\n  }\n  \n  .service-title {\n    font-size: 24px;\n    font-weight: bold;\n    margin-top: 20px;\n    margin-bottom: 10px;\n  }\n  \n  .service-description {\n    font-size: 18px;\n    line-height: 1.5;\n    color: #999;\n  }\n  \n  @media (max-width: 768px) {\n    .service {\n      width: 100%;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
